@if (isStandardView) {
  <app-admin-report-list />
} @else if (isEditView) {
  <app-admin-report-edit />
} @else if (isCreateView) {
  <app-admin-report-create />
}
